import { Controller, FieldValues } from 'react-hook-form';
import Checkbox from '../DefaultCheckbox';
import { IReactHookFormCheckboxGroupProps } from '../index';
import Typography from '../../Typography';
import FormControlLabel from '../../FormControl/components/FormControlLabel';
import FormHelperText from '../../FormHelperText';
import { S5 } from '../../../theme';

const ReactHookFormCheckboxGroup = <TFieldValues extends FieldValues>(
  props: IReactHookFormCheckboxGroupProps<TFieldValues>,
) => {
  const {
    name,
    control,
    errorMessage,
    defaultValue,
    rules,
    data,
    ...checkboxProps
  } = props;

  return (
    <>
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue}
        rules={rules}
        render={({
          field: {
            value, onChange, onBlur, ref,
          },
        }) => (
          <>
            {data.map(({ dataFlag, dataName }) => (
              <FormControlLabel
                key={dataFlag}
                label={<Typography variant="body2" color={S5}>{dataName}</Typography>}
                control={(
                  <Checkbox
                    {...checkboxProps}
                    onChange={() => {
                      if (!value.includes(dataFlag)) {
                        onChange([...value, dataFlag]);
                        return;
                      }
                      const newValue = value.filter((val: number) => val !== dataFlag);
                      onChange(newValue);
                    }}
                    checked={value.includes(dataFlag)}
                    onBlur={onBlur}
                    ref={ref}
                  />
                )}
              />
            ))}
          </>
        )}
      />
      {!!errorMessage && (
        <FormHelperText variant="outlined" error>
          {errorMessage}
        </FormHelperText>
      )}
    </>
  );
};

export default ReactHookFormCheckboxGroup;
